// Amplitude
import * as Amplitude from '@amplitude/node';

export class AmplitudeAPI {
    constructor(objEvent) {
        this.objEvent = objEvent;
    }

    async eventLog() {
        var client = Amplitude.init(process.env.REACT_APP_AMPLITUDE);
            client.logEvent(this.objEvent);

        client.flush();
    }

}